(function () {
    'use strict';

    /**
     * Featured stats section - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_FeaturedStats.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "featuredStatsSection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionFeaturedStats', sectionFeaturedStats);

    function sectionFeaturedStats() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionFeaturedStatsCtrl,
            controllerAs: 'featuredStatsSection'
        };
    }

    SectionFeaturedStatsCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionFeaturedStatsCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        vm.items = [];

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Load the featured stats (counters) of the event
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise}
         */
        function load(eventId, lang) {
            return ApiFactory.GetFeaturedStats(eventId, lang).then(function (response) {
                vm.items = response.data;
            });
        }
    }
})();
